<script setup lang="ts">
import { ref } from 'vue';
import { RouterView } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import AdminSidebar from '@/sites/tfs/components/admin/AdminSidebar.vue';
import AdminHeader from '@/sites/tfs/components/admin/AdminHeader.vue';
import NotificationIcon from '@/sites/tfs/components/notifications/NotificationIcon.vue';

const { logout, user } = useAuth();

const isSidebarOpen = ref(false);

const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value;
};

const closeSidebar = () => {
  isSidebarOpen.value = false;
};

const handleLogout = async () => {
  await logout();
};
</script>

<template>
  <div class="min-h-screen bg-noir-950 text-cream-100 flex relative">
    <!-- Subtle texture overlay -->
    <div class="fixed inset-0 pointer-events-none opacity-5">
      <div class="absolute inset-0 bg-[url('@/assets/textures/gradient-mesh.svg')]"></div>
    </div>

    <!-- Sidebar Component - Glassmorphism -->
    <AdminSidebar
      :is-open="isSidebarOpen"
      :user="user"
      @close="closeSidebar"
      @logout="handleLogout"
    />

    <!-- Main Content -->
    <main class="flex-1 flex flex-col min-w-0 overflow-hidden relative z-10">
      <!-- Header Component (Mobile Only) -->
      <AdminHeader
        :user="user"
        @toggle-sidebar="toggleSidebar"
        @logout="handleLogout"
      />

      <div class="hidden md:flex items-center justify-end px-8 py-3 border-b border-noir-800 bg-noir-900/40 backdrop-blur-sm">
        <NotificationIcon />
      </div>

      <!-- Content Area with subtle border -->
      <div class="flex-1 overflow-auto p-4 md:p-8 bg-noir-950 border-l border-noir-800">
        <RouterView />
      </div>
    </main>
  </div>
</template>
